import { v4 as uuid, validate as uuidValidate } from 'uuid'

import { createObject } from 'src/utils/objects'

const createReportId = () => uuid()
const validateReportId = (reportId) => uuidValidate(reportId)

/**
 * Create a report role object
 * @param {Object} report
 * @param {string} userId
 * @returns {ReportRole}
 */
const createReportRole = (report, userId) => ({
  isArchived: report.isArchived || false,
  isDeleted: report.isDeleted || false,
  isFavorite: report.isFavorite || false,
  isMetric: report.isMetric || false,
  isRevoked: report.isRevoked || false,
  role: report.role || [],
  userId,
})

const pushRole = (report, role) => {
  const roles = report.roles || []
  roles.push(role)
  return roles
}

/**
 * Create a report object.
 * @param nav
 * @param originalQuery
 * @returns {Report}
 */
const createReport = (nav, originalQuery) => {
  const {
    associationId,
    columns,
    defaultRole,
    docId,
    index,
    isArchived,
    isClientEnforced,
    isDeleted,
    isFavorite,
    isMetric,
    ownerId,
    parameters,
    reportLabel,
    reportPath,
    roles,
    scope,
    shares,
    subId,
  } = originalQuery || {}

  const newQuery = {
    associationId: associationId || 'all-associations',
    baseReportName: nav.baseReportName,
    columns: columns || [],
    defaultRole: defaultRole || 'editor',
    docId,
    index,
    isArchived: isArchived || false,
    isClientEnforced: isClientEnforced || false,
    isDeleted: isDeleted || false,
    isFavorite: isFavorite || false,
    isMetric: isMetric || false,
    ownerId: ownerId || 'all-users',
    parameters: parameters || [],
    reportLabel: reportLabel || 'Unnamed Report',
    reportPath: reportPath || uuid(),
    roles: roles || [],
    routeName: nav.routeName,
    scope: scope || 'local',
    shares: shares || [],
    subId: subId || 'all-secondary',
  }

  return newQuery
}

const copyReport = (nav, selectedReport, newQueryIndex) => {
  const overwrites = {
    index: newQueryIndex,
    reportLabel: `${selectedReport.reportLabel} [Copy]`,
  }

  return createObject(selectedReport, overwrites)
}

const copyReports = (nav, querySet) => querySet.map((entry, entryIndex) => copyReport(nav, entry, entryIndex))

export { copyReport, copyReports, createReport, createReportId, createReportRole, pushRole, validateReportId }
